import { useEffect, useRef, useState } from 'react';

import { Button, formatNumber, PageTitle } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { Combobox, Datepicker, HookFormResolver, Number, Text } from '@dec/shared';
import { type HookFormMethods } from '@dec/shared';
import { BtnGroup, BtnToolbar, Col, Row } from '@dec/shared';
import {
  type CheckboxSelectionCallbackParams,
  type ColDef,
  type GridApi,
  type ValueFormatterParams
} from 'ag-grid-community';
import { ActionsGrid } from 'app/components/grid';
import { type ActionColumn } from 'app/components/grid/actions-column';
import GridApplication, {
  GridContainer,
  OnlyGrid,
  type RowSelectionValue
} from 'app/components/grid/gridApplication';
import { ConfirmDialog } from 'app/core/dialog';
import { notificationSuccess, notificationWarning } from 'app/core/toast';
import { useSpinnerActions } from 'app/layouts/store';
import { catalogs } from 'app/modules/Parameters/Catalog/Catalog/services/catalog';
import { useCatalogList } from 'app/modules/Parameters/Catalog/Catalog/services/useCatalog';
import { getApplicationEnvironmentByName } from 'app/modules/Parameters/EnvironmentVariable/hooks/useEnvironment';
import { label as labelCommon } from 'app/modules/translation';
import env from 'env';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import DateParser from 'utils/date';
import * as yup from 'yup';

import {
  type DetailPaymentsReceived,
  type ReconciliationOfPaymentItemRequest,
  type TaxReturnPayment
} from '../models/Payment';
import { BaseUrPaymentDeclaration, paymentService } from '../services/payment.service';

interface MetadataConciliation {
  paymentRegistred?: TaxReturnPayment;
  bankInfo?: DetailPaymentsReceived;
}

const validationsSearch = yup.object().shape({
  dateFrom: yup.date().nullable(),
  dateTo: yup.date().when('dateFrom', {
    is: (dateFrom: Date) => !!dateFrom,
    then: (schema) =>
      schema
        .nullable()
        // .required(i18next.t('management-report.validations.dateRequired'))
        .min(yup.ref('dateFrom'), i18next.t('management-report.validations.dateToGreaterThan')),
    otherwise: (schema) => schema.nullable()
  })
});

const defaultValuesPayments = {
  relations: ['Currency', 'TaxReturn', 'TaxReturn.Taxpayer'],
  state: 'pending',
  OrderByPaymentDate: true
};

const defaultValuesBankPayments = {
  state: 'received',
  OrderByPaymentDate: true
};

export const PaymentMatchPage = () => {
  const { t } = useTranslation();
  const paymentsTaxpayerTitle = t('taxpayer-payments.title.paymentsTaxpayer');
  const paymentsTaxCollectTitle = t('taxpayer-payments.title.paymentsTaxCollect');
  const conciliationTitle = t('taxpayer-payments.title.concialiation');
  const amountTaxpayerLabel = t('taxpayer-payments.label.amountTaxpayer');
  const amountBankLabel = t('taxpayer-payments.label.amountBank');
  const diferentCurrencyCodeMessage = t('taxpayer-payments.messages.diferentCurrencyCode');
  const exceedsToleranceMessage = t('taxpayer-payments.messages.exceedsTolerance');
  const paymentGreaterThenMessage = t('taxpayer-payments.messages.paymentGreaterThen');

  const { showSpinner, hideSpinner } = useSpinnerActions();
  const grid1 = useRef<GridApi | null>(null);
  const grid2 = useRef<GridApi | null>(null);
  const grid3 = useRef<GridApi | null>(null);
  //  const {loading:loadingEnviroment,environemnt} =useApplicationEnvironmentByName('payment_tolerance_percentage')
  const [tolerance, setTolerance] = useState<number>(0);

  const [searchPayments, setSearchPayments] = useState<any>(defaultValuesPayments);
  const [searchBankPayments, setSeachBankPayments] = useState<any>(defaultValuesBankPayments);
  const [toReconcile, setToReconcile] = useState<Array<MetadataConciliation>>([] as Array<any>);
  const [paymentsRegistred, setPaymentRegistred] = useState<Array<TaxReturnPayment>>([]);
  const [bankInfo, setBankInfo] = useState<DetailPaymentsReceived>();
  const [reload, setReload] = useState<boolean>(false);
  const [redraw, setRedraw] = useState<boolean>();

  //const [grid1,setGrid1]=useState<ColDef[]>([]);
  //const [grid2,setGrid2]=useState<ColDef[]>([]);

  const [{ data: taxCollectors, loading: loadingTaxCollector, error: errorTaxCollector }] =
    useCatalogList(catalogs.taxCollector);

  const comprobar = (params: CheckboxSelectionCallbackParams) => {
    return !toReconcile.some((x) => x.paymentRegistred?.id === params.data.id);
    //return !toReconcile.some((x) => x.paymentRegistred?.id === id);
  };
  //const colGrid1 = (list: any[])=>{
  const colDefsGrid1: Array<ColDef> = [
    // {
    //   headerName: headers(t, 'actions'),
    //   cellRenderer: ActionsGrid,
    //   cellRendererParams: {
    //     actions: acciones
    //   }
    // },
    {
      headerName: '',
      colId: 'grid1',
      maxWidth: 45,
      checkboxSelection: comprobar
    },
    {
      headerName: t('taxpayer-payments.label.date-payment'),
      field: 'paymentDate',
      valueFormatter: (params: ValueFormatterParams) => {
        return DateParser.toString(params.value);
      }
    },
    {
      headerName: t('taxpayer-payments.label.swiftNumber'),
      field: 'swift',
      valueFormatter: (params: ValueFormatterParams) => {
        return params.value ?? '---';
      }
    },
    {
      headerName: t('taxpayer-payments.label.amount'),

      field: 'amount',
      cellStyle: (params: any) => {
        return { 'text-align': 'right' };
      },
      valueFormatter: (params: ValueFormatterParams) => {
        const code = params?.data?.currency?.code;
        const codeCurrency = code ? code : '';
        return `${formatNumber(params.value)} ${codeCurrency}`;
      }
    },

    {
      headerName: t('config.tin'),
      field: 'taxReturn.taxPayerNit'
    },
    {
      headerName: t('taxreturn-report.label.name'),
      field: 'taxReturn.taxPayerName'
    },
    {
      headerName: t('taxpayer-payments.label.payment-number'),
      field: 'paymentNumber',
      cellRenderer: function (params: any) {
        const url =
          `${env.publicUrl}/taxpayer/taxreturn-payment/view?taxReturnId=` +
          params.data.taxReturn.id +
          '&paymentId=' +
          params.data.id;
        const text = params.data.paymentNumber;

        // ahora se devuelve el vinculo
        return (
          <a href={url} target="_blank" rel="noopener noreferrer">
            {text}
          </a>
        );
      }
    },
    {
      headerName: t('config.tinLegend'),
      field: 'taxReturn.taxReturnNumber',
      cellRenderer: function (params: any) {
        const url = `${env.publicUrl}/reports/taxreturn/preview/${params.data.taxReturnId}`;
        const text = params.data.taxReturn.taxReturnNumber;

        // ahora se devuelve el vinculo
        return (
          <a href={url} target="_blank" rel="noopener noreferrer">
            {text}
          </a>
        );
      }
    }
  ];

  const colDefsGrid2: Array<ColDef> = [
    {
      headerName: '',
      colId: 'grid2',
      maxWidth: 45,
      checkboxSelection: (params: CheckboxSelectionCallbackParams) => {
        return !toReconcile.some((x) => x.bankInfo?.id === params.data.id);
      }
    },
    {
      headerName: t('taxpayer-payments.label.date-payment'),
      field: 'date',
      valueFormatter: (params: ValueFormatterParams) => {
        return params.value ? DateParser.toString(params.value) : '---';
      }
    },
    {
      headerName: t('taxpayer-payments.label.swiftNumber'),
      field: 'swift',
      valueFormatter: (params: ValueFormatterParams) => {
        return params.value ?? '---';
      }
    },
    {
      headerName: t('taxpayer-payments.label.amount'),
      field: 'amount',
      cellStyle: (params: any) => {
        return { 'text-align': 'right' };
      },
      valueFormatter: (params: ValueFormatterParams) => {
        const code = params?.data?.currencyCode;
        const codeCurrency = code ? code : '';
        return params.value ? `${formatNumber(params.value)} ${codeCurrency}` : '---';
      }
    },
    {
      headerName: t('taxreturn-evaluation.label.taxpayer'),
      field: 'taxpayer',
      valueFormatter: (params: ValueFormatterParams) => {
        return params.value ?? '---';
      }
    },

    {
      headerName: t('common.label.paymentReference'),
      field: 'reference',
      valueFormatter: (params: ValueFormatterParams) => {
        return params.value ?? '---';
      }
    }
  ];
  //   return colDefsGrid2;
  // }

  const actions: Array<ActionColumn> = [
    {
      action: ButtonAction.delete,
      variant: 'danger',
      onClick: (row: MetadataConciliation) => {
        setToReconcile(toReconcile.filter((x) => x.bankInfo?.id !== row.bankInfo?.id));
        setRedraw(redraw !== undefined ? !redraw : false);
        grid1.current?.deselectAll();
        grid2.current?.deselectAll();
      }
    }
  ];

  const colToReconcile: Array<ColDef> = [
    {
      headerName: t('taxpayer-payments.label.date-payment'),
      field: 'bankInfo.date',

      valueFormatter: (params: ValueFormatterParams) => {
        return params.value ? DateParser.toString(params.value) : '---';
      }
    },
    {
      headerName: t('config.tin'),
      field: 'paymentRegistred.taxReturn.taxPayerNit'
    },
    {
      headerName: t('taxreturn-report.label.name'),
      field: 'paymentRegistred.taxReturn.taxPayerName'
    },
    {
      headerName: amountTaxpayerLabel,
      field: 'paymentRegistred.amount',
      cellStyle: () => {
        return { 'text-align': 'right' };
      },
      valueFormatter: (params: ValueFormatterParams) => {
        const code = params?.data?.paymentRegistred?.currency.code;
        const codeCurrency = code ? code : '';
        return params.value ? `${formatNumber(params.value)} ${codeCurrency}` : '---';
      }
    },
    {
      headerName: amountBankLabel,
      field: 'bankInfo.amount',
      cellStyle: () => {
        return { 'text-align': 'right' };
      },
      valueFormatter: (params: ValueFormatterParams) => {
        const code = params?.data?.bankInfo?.currencyCode;
        const codeCurrency = code ? code : '';
        return params.value ? `${formatNumber(params.value)} ${codeCurrency}` : '---';
      }
    },
    {
      headerName: t('taxpayer-payments.label.swiftNumber'),
      field: 'bankInfo.swift',
      valueFormatter: (params: ValueFormatterParams) => {
        return params.value ?? '---';
      }
    },
    {
      headerName: t('taxpayer-payments.label.payment-number'),
      field: 'paymentRegistred.paymentNumber'
    },
    {
      headerName: t('common.label.actions'),
      cellRenderer: ActionsGrid,
      cellRendererParams: {
        actions: actions
      }
    }
  ];

  useEffect(() => {
    const loadTolerance = async () => {
      const response = await getApplicationEnvironmentByName('payment_tolerance_percentage');
      const tolerance = parseInt(response?.value ?? '0');
      setTolerance(tolerance);
    };
    loadTolerance();
  }, []);

  const validateToleranceAndNotificate = (
    payments: Array<TaxReturnPayment>,
    bankPayment: DetailPaymentsReceived
  ): boolean => {
    const percentage = tolerance / 100;
    const totalPayments = payments.reduce((sum, current) => sum + current.amount, 0);
    const bankAmount = bankPayment?.amount as number;
    if (totalPayments > bankAmount) {
      // el pago reportado es mayor que el informado por el banco
      // esto se permite unicamente si la diferencia esta dentro del margen de tolerancia
      const valid: boolean = totalPayments <= bankAmount * (1 + percentage);
      if (!valid) {
        notificationWarning(paymentGreaterThenMessage);
        return false;
      }
    } else {
      const value = bankAmount * percentage;
      const valid = totalPayments + value >= bankAmount;
      if (!valid) {
        notificationWarning(exceedsToleranceMessage.replace('[tolerence]', tolerance.toString()));
        return false;
      }
    }

    return true;
  };

  const validateTolerance = (
    toleranceValue: number,
    payments: Array<TaxReturnPayment>,
    bankPayment: DetailPaymentsReceived
  ): boolean => {
    const porcentage = (toleranceValue as number) / 100;
    const totalPayments = payments.reduce((sum, current) => sum + current.amount, 0);
    const bankAmount = bankPayment?.amount as number;
    const value = bankAmount * porcentage;
    const valid = totalPayments + value >= bankAmount;
    if (!valid) {
      return false;
    }
    return true;
  };

  const validateEqualCurrency = (
    payments: Array<TaxReturnPayment>,
    bankPayment: DetailPaymentsReceived
  ): boolean => {
    const codeCurrency = payments[0]?.currency?.code;
    if (!payments.every((x) => x.currency?.code === codeCurrency)) {
      notificationWarning(diferentCurrencyCodeMessage);
      return false;
    }

    if (!payments.every((x) => x.currency?.code === bankPayment.currencyCode)) {
      notificationWarning(diferentCurrencyCodeMessage);
      return false;
    }

    return true;
  };
  const toggleRedraw = () => {
    // setGrid1(colGrid1(toReconcile));
    //setGrid2(colGrid2(toReconcile));
    // setReload(!reload)

    setPaymentRegistred([]);
    setBankInfo(undefined);
    setRedraw(redraw !== undefined ? !redraw : false);
    grid1.current?.deselectAll();
    grid2.current?.deselectAll();
  };

  const resetAll = () => {
    setToReconcile([]);
    setPaymentRegistred([]);
    setBankInfo(undefined);
    setReload(!reload);
  };

  useEffect(() => {
    if (redraw !== undefined) {
      grid1.current?.updateGridOptions({ columnDefs: colDefsGrid1 });
      grid2.current?.updateGridOptions({ columnDefs: colDefsGrid2 });
      grid3.current?.updateGridOptions({ columnDefs: colToReconcile });
    }
  }, [redraw, grid1]);

  const onPaymentRegistredSelected = (event: RowSelectionValue) => {
    if (event.isSelected) {
      if (bankInfo) {
        const newArray = [...toReconcile];
        event.data.forEach((x: any) => {
          newArray.push({ paymentRegistred: x, bankInfo: bankInfo });
        });
        if (
          validateEqualCurrency(event.data, bankInfo) &&
          validateToleranceAndNotificate(event.data, bankInfo)
        ) {
          setToReconcile(newArray);
          toggleRedraw();
        } else {
          grid2.current?.deselectAll();
        }
      } else {
        setPaymentRegistred(event.data);
      }
    } else {
      if (paymentsRegistred?.some((x) => x.id === event.data.id)) {
        setPaymentRegistred(paymentsRegistred.filter((x) => x.id !== event.data.id));
      }
    }
  };

  const onBankInfoSelected = (event: RowSelectionValue) => {
    if (event.isSelected) {
      if (paymentsRegistred?.length > 0) {
        const newArray = [...toReconcile];

        paymentsRegistred.forEach((x: any) => {
          newArray.push({ paymentRegistred: x, bankInfo: event.data });
        });
        // newArray.push({paymentRegistred:paymentsRegistred,bankInfo:event.data})
        if (
          validateEqualCurrency(paymentsRegistred, event.data) &&
          validateToleranceAndNotificate(paymentsRegistred, event.data)
        ) {
          setToReconcile(newArray);
          toggleRedraw();
        } else {
          grid2.current?.deselectAll();
        }
      } else {
        setBankInfo(event.data);
      }
    } else {
      if (event.data.id === bankInfo?.id) {
        setBankInfo(undefined);
      }
    }
  };

  const onSearch = (values: any) => {
    setSearchPayments({
      ...defaultValuesPayments,
      tin: values.nit,
      dateFrom: values.dateFrom,
      dateTo: values.dateTo,
      amountFrom: values.amountFrom,
      amountTo: values.amountTo
    } as any);

    setSeachBankPayments({
      ...defaultValuesBankPayments,
      taxCollectorId: values.taxCollector?.id,
      dateFrom: values.dateFrom,
      dateTo: values.dateTo,
      amountFrom: values.amountFrom,
      amountTo: values.amountTo
    } as any);
  };

  const onCancel = () => {
    // cancelado
  };

  const onSubmit = async () => {
    if (toReconcile?.length > 0) {
      const ok = await ConfirmDialog({
        titleModal: t('common.dialog.warning-title'),
        message: t('common.messages.confirm'),
        okButton: labelCommon('ok'),
        cancelButton: labelCommon('cancel')
      });

      if (ok) {
        const items = toReconcile.map((x) => {
          return {
            taxReturnPaymentId: x.paymentRegistred?.id,
            paymentsReceivedId: x.bankInfo?.id
          } as ReconciliationOfPaymentItemRequest;
        });
        try {
          showSpinner();
          const response = await getApplicationEnvironmentByName('payment_tolerance_percentage');
          const tolerance = parseInt(response?.value ?? '0');

          const toValidate = [] as Array<{
            taxpayerPayments: Array<TaxReturnPayment>;
            bankPayment: DetailPaymentsReceived;
          }>;
          toReconcile.forEach((x) => {
            if (!toValidate.find((y) => y.bankPayment.id === x.bankInfo?.id)) {
              const value = {
                taxpayerPayments: toReconcile
                  .filter((t) => t.bankInfo?.id === x.bankInfo?.id)
                  .map((m) => m.paymentRegistred as TaxReturnPayment),
                bankPayment: x.bankInfo as DetailPaymentsReceived
              };
              toValidate.push(value);
            }
          });
          const resultWithError = toValidate.some(
            (x) => validateTolerance(tolerance, x.taxpayerPayments, x.bankPayment) === false
          );
          if (resultWithError) {
            notificationWarning(
              exceedsToleranceMessage.replace('[tolerence]', tolerance.toString())
            );
            setTolerance(tolerance);
            hideSpinner();
          } else {
            await paymentService.createPaymentMatch({ items });
            resetAll();
            hideSpinner();
            notificationSuccess(t('common.messages.savedSucessfully'));
          }
        } catch (e) {
          hideSpinner();
        }
      }
    }
  };

  if (loadingTaxCollector || errorTaxCollector) {
    return <></>;
  }

  // if(grid1.length ===0 && grid2.length===0){
  //   return <></>
  // }

  return (
    <>
      <PageTitle title={t('taxpayer-payments.title.reconciliationPayments')} />
      <HookFormResolver onSubmit={onSearch} validations={validationsSearch}>
        {({ formState: { errors }, reset, setValue, control }: HookFormMethods) => {
          return (
            <>
              <Row>
                <Col>
                  <Combobox
                    code="id"
                    display="name"
                    data={taxCollectors}
                    label={t('taxpayer-payments.label.taxCollector')}
                    name="taxCollector"
                  />
                </Col>
                <Col>
                  <Text label={t('config.tin')} name="nit" />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Datepicker label={t('common.label.dateFrom')} name="dateFrom" />
                </Col>
                <Col>
                  <Datepicker label={t('common.label.dateTo')} name="dateTo" />
                </Col>
                <Col>
                  <Number
                    includeThousandsSeparator={true}
                    allowDecimal={true}
                    label={t('taxpayer-payments.label.amountFrom')}
                    name="amountFrom"
                  />
                </Col>
                <Col>
                  <Number
                    includeThousandsSeparator={true}
                    allowDecimal={true}
                    label={t('taxpayer-payments.label.amountTo')}
                    name="amountTo"
                  />
                </Col>
              </Row>
              <Row></Row>
              <BtnToolbar>
                <BtnGroup>
                  <Button
                    action={ButtonAction.clean}
                    variant={'secondary'}
                    type={'reset'}
                    onClick={() => {
                      setSearchPayments(defaultValuesPayments);
                      setSeachBankPayments(defaultValuesBankPayments);
                      reset({
                        taxCollector: null,
                        dateFrom: null,
                        dateTo: null
                      });
                    }}
                  />
                </BtnGroup>
                <BtnGroup>
                  <Button action={ButtonAction.find} type={'submit'} variant={'primary'} />
                </BtnGroup>
              </BtnToolbar>
            </>
          );
        }}
      </HookFormResolver>
      <hr></hr>
      <Row>
        <Col>
          <h2> {paymentsTaxpayerTitle}</h2>
          <GridApplication
            onGridReady={(params) => {
              grid1.current = params.api;
            }}
            toggleReload={reload}
            url={`${BaseUrPaymentDeclaration}`}
            columnDefs={colDefsGrid1}
            search={searchPayments}
            rowSelection="multiple"
            rowSelected={onPaymentRegistredSelected}
          />
        </Col>

        <Col>
          <h2> {paymentsTaxCollectTitle}</h2>
          <GridApplication
            onGridReady={(params) => (grid2.current = params.api)}
            toggleReload={reload}
            url={`/taxreturnpayments/received/detail`}
            columnDefs={colDefsGrid2}
            search={searchBankPayments}
            rowSelection="single"
            rowSelected={onBankInfoSelected}
          />
        </Col>
      </Row>
      <Row className="mt-5">
        <Col>
          <h2> {conciliationTitle}</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <GridContainer>
            <OnlyGrid
              onGridReady={(params) => (grid3.current = params.api)}
              data={toReconcile}
              columnDefs={colToReconcile}
            />
          </GridContainer>
        </Col>
      </Row>
      <BtnToolbar>
        <BtnGroup>
          <Button action={ButtonAction.cancel} variant="secondary" onClick={onCancel} />
        </BtnGroup>
        <BtnGroup>
          <Button action={ButtonAction.save} type="button" onClick={onSubmit} variant="primary" />
        </BtnGroup>
      </BtnToolbar>
    </>
  );
};
